import { useState, useMemo, useEffect } from "react";
import './LandingPage.css';
import {
  TextField,
  Button,
  Container,
  styled,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
  InputLabel,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SearchIcon from '@mui/icons-material/Search';
import { tableCellClasses } from '@mui/material/TableCell';
import TableMenuButton from "components/button/TableMenuButton";
import { useLocation } from 'react-router-dom';
import { useGetUsersQuery, useUpdateRoleMutation } from '../../api/api';
import { useNavigate } from "react-router-dom";
import UserSwitch from "components/switch/UserSwitch";
import SE2050Background from "../../assets/landing-page-image.png";



const LandingPage = () => {

    return (
        // <StyledContainer>
        //     <Box >

        //      </Box>
        // </StyledContainer>
            <div className="welcome container-fluid">
            <div className="row full-height align-items-stretch d-flex flex-fill d-flex justify-content-start">
                <div className="col-sm form-side p-0">
                <div className="welcomemodal p-4 h-100">
                    <div className="h-100 align-items-start justify-content-center d-flex pr-2 pt-5 mt-3">
                    <div className="formwrap">
                        <div className="formlogo pb-5 mb-1"></div>
                        <div className="loginform" id="loginform">
                        <form>
                            <div className="formheader pb-4">
                            <h3 className="page-header">Sign In</h3>
                            <p className="page-description">
                                Sign in or register to start your session
                            </p>
                            {/* <p>
                                Don&apos;t have an account yet?
                                <a
                                href="#"
                                id="loginSwitcher"
                                
                                >
                                Register
                                </a>
                            </p> */}
                            </div>
                            <div className="form-group input-fields">
                            <label htmlFor="loginemail" className="input-label">
                                Email
                            </label>
                            <input
                                type="email"
                                name="email"
                                autoComplete="username"
                                id="loginemail"
                                className="form-control shadow-none"
                            />
                            </div>
                            <div className="form-group input-fields">
                            <label htmlFor="loginpassword" className="input-label">
                                Password
                            </label>
                            <input
                                type="password"
                                name="password"
                                autoComplete="new-password"
                                minLength={8}
                                className="form-control shadow-none"
                                id="loginpassword"
                            />
                            </div>
                            <div className="form-group" id="rememberme-cont">
                            <input
                                type="checkbox"
                                className="form-check-input shadow-none"
                                id="remember-me"
                                name="remember-me"
                            />
                            <label>Remember Me</label>
                            </div>
                            <div className="captcha-container form-group" />
                            <div className="alert alert-danger error-message form-group" />
                            <button
                            className="btn btn-primary btn-block btn-lg mt-4"
                            type="submit"
                            id="btn-login"
                            >
                            Sign in
                            </button>
                            <p className="pt-5 mt-1" style={{ color: "#1A1A1A" }}>
                            Don't have an account?
                            <a href="#" id="loginSwitcher">
                                Register
                            </a>
                            </p>
                            <a href="#" id="forgotswitcher">
                            Forgot Password?
                            </a>
                        </form>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="intro-side">
                <div className="logo"></div>
                </div>
            </div>
            </div>

    );
};

export default LandingPage;

const StyledContainer = styled(Container)({
  marginBottom: 24,
});